import Config from '@/config';
import http, { HttpPromise } from './http';

export default {

  customer: { // для заказчика
    // список конкурсов на подряд
    list: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/contract-work/list/`, { params });
      return response.data.result;
    },
    // получить данные по конкурсу на подряд
    detail: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/contract-work/detail/`, { params });
      return response.data.result;
    },
    // получить данные для создания конкурса на подряд
    parameters: async (): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/contract-work/parameters/`);
      return response.data.result;
    },
    // получить список подрядчиков, участвовавших в архивных конкурсах текущего заказчика
    contractors: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/contract-work/contractors/`, data);
      return response.data.result;
    },
    // создать новый | редактировать ранее созданный конкурс на ген подряд
    save: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/contract-work/save/`, data);
      return response.data.result;
    },
    // сменить статус
    status: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/contract-work/status/`, data);
      return response.data.result;
    },
    // выбрать победителя
    winner: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/contract-work/winner/`, data);
      return response.data.result;
    },
    // смена флага пропуска предложения для подрядчиков
    changeSkip: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/contract-work/offer/skip/`, data);
      return response.data.result;
    },
    // скачать предложения от подрядчиков
    downloadResult: async (params): Promise<HttpPromise> => http.get(`${Config.apiHost}/customer/contract-work/result/`, {
      params,
      responseType: 'blob',
    }),
  },
  contractor: { // для подрядчика
    // список конкурсов на подряд
    list: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/contractor/contract-work/list/`, { params });
      return response.data.result;
    },
    // получить данные по конкурсу на подряд
    detail: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/contractor/contract-work/detail/`, { params });
      return response.data.result;
    },
    // получить данные для подачи предложения по конкурсу на подряд
    contractorParameters: async (): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/contractor/contract-work/parameters/`);
      return response.data.result;
    },
    // подать предложение по конкурсу на подряд
    save: async (data): Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/contractor/contract-work/update/`, data);
      return response.data.result;
    },
  },
};
